/**
 * Saves an in-memory Blob to the user's disk under `filename`.
 *
 * Promoted out of `components/dev/reports/shared/report-export.util.ts` when the
 * XBRL Files download started building its zip client-side and needed the same
 * plumbing from production code.
 */
export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
